(function () {
  // Helper: smooth scroll
  function smoothScrollTo(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth" });
  }

  var root = document.getElementById("bass-boots-drop-002");
  if (!root) return;

  // ===================== COUNTDOWN TO MIDNIGHT =====================
  (function initCountdown() {
    var hEl = document.getElementById("bb-countdown-hours");
    var mEl = document.getElementById("bb-countdown-mins");
    var sEl = document.getElementById("bb-countdown-secs");
    if (!hEl || !mEl || !sEl) return;

    function updateCountdown() {
      var now = new Date();
      var end = new Date();
      end.setHours(24, 0, 0, 0); // midnight tonight

      var diff = end - now;
      var totalSeconds = Math.max(0, Math.floor(diff / 1000));
      var hours = Math.floor(totalSeconds / 3600);
      var mins = Math.floor((totalSeconds % 3600) / 60);
      var secs = totalSeconds % 60;

      hEl.textContent = String(hours).padStart(2, "0");
      mEl.textContent = String(mins).padStart(2, "0");
      sEl.textContent = String(secs).padStart(2, "0");
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  })();

  // ===================== VIEWER COUNT JITTER =====================
  (function initViewers() {
    var viewersEl = document.getElementById("bb-viewers-count");
    if (!viewersEl) return;

    var viewers = parseInt(viewersEl.textContent || "27", 10) || 27;

    function updateViewers() {

      var rand = Math.random();
      var delta = 0;

      if (rand < 0.20) {
        delta = -1;
      } else if (rand < 0.45) {
        delta = 0;
      } else if (rand < 0.90) {
        delta = 1;
      } else {
        delta = Math.random() < 0.5 ? -2 : 2;
      }

      viewers += delta;

      if (viewers < 22) viewers = 22;
      if (viewers > 34) viewers = 34;

      viewersEl.textContent = viewers;

      setTimeout(updateViewers, 7000 + Math.random() * 6000);
    }

    setTimeout(updateViewers, 7000 + Math.random() * 6000);
  })();

  // ===================== PRODUCT IMAGE CAROUSEL =====================
  function initProductGallery(container) {
    var scope = container || document;
    var galleries = scope.querySelectorAll
      ? scope.querySelectorAll("[data-product-gallery]")
      : [];

    galleries.forEach(function (gallery) {
      if (gallery.getAttribute("data-gallery-initialized") === "true") {
        return;
      }

      gallery.setAttribute("data-gallery-initialized", "true");

      var tabs = gallery.querySelectorAll("[data-gallery-color]");
      var tracks = gallery.querySelectorAll("[data-gallery-track]");
      var dots = gallery.querySelectorAll("[data-gallery-dot]");
      var activeColor = "chrome";
      var currentIndex = 0;
      var scrollTimer;

      function getActiveTrack() {
        return gallery.querySelector(
          '[data-gallery-track="' + activeColor + '"]'
        );
      }

      function setActiveDot(index) {
        currentIndex = index;

        dots.forEach(function (dot) {
          var dotIndex = parseInt(
            dot.getAttribute("data-gallery-dot") || "0",
            10
          );

          dot.classList.toggle(
            "bb-product-gallery-dot-active",
            dotIndex === currentIndex
          );

          dot.setAttribute(
            "aria-current",
            dotIndex === currentIndex ? "true" : "false"
          );
        });
      }

      function getSlideWidth(track) {
        if (!track) return 1;
        return track.clientWidth > 0 ? track.clientWidth : 1;
      }

      function goToSlide(index, smooth) {
        var track = getActiveTrack();
        if (!track) return;

        var imageCount = track.querySelectorAll("img").length;
        var maxIndex = Math.max(0, imageCount - 1);
        var safeIndex = Math.max(0, Math.min(index, maxIndex));
        var left = getSlideWidth(track) * safeIndex;

        if (typeof track.scrollTo === "function") {
          track.scrollTo({
            left: left,
            behavior: smooth === false ? "auto" : "smooth",
          });
        } else {
          track.scrollLeft = left;
        }

        setActiveDot(safeIndex);
      }

      function setActiveColor(color) {
        activeColor = color === "black" ? "black" : "chrome";

        tabs.forEach(function (tab) {
          var selected =
            tab.getAttribute("data-gallery-color") === activeColor;

          tab.classList.toggle(
            "bb-product-gallery-tab-active",
            selected
          );

          tab.setAttribute(
            "aria-pressed",
            selected ? "true" : "false"
          );
        });

        tracks.forEach(function (track) {
          var selected =
            track.getAttribute("data-gallery-track") === activeColor;

          track.classList.toggle(
            "bb-product-gallery-track-active",
            selected
          );

          if (selected) {
            track.scrollLeft = 0;
          }
        });

        setActiveDot(0);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          setActiveColor(
            tab.getAttribute("data-gallery-color") || "chrome"
          );
        });
      });

      dots.forEach(function (dot) {
        dot.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          var index = parseInt(
            dot.getAttribute("data-gallery-dot") || "0",
            10
          );

          goToSlide(index, true);
        });
      });

      tracks.forEach(function (track) {
        function syncDotToScroll() {
          if (
            !track.classList.contains(
              "bb-product-gallery-track-active"
            )
          ) {
            return;
          }

          var width = getSlideWidth(track);
          var index = Math.round(track.scrollLeft / width);
          setActiveDot(index);
        }

        track.addEventListener(
          "scroll",
          function () {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(syncDotToScroll, 60);
          },
          { passive: true }
        );

        track.addEventListener(
          "touchend",
          function () {
            setTimeout(syncDotToScroll, 80);
          },
          { passive: true }
        );
      });

      window.addEventListener("resize", function () {
        goToSlide(currentIndex, false);
      });

      setActiveColor("chrome");
    });
  }

  initProductGallery(root);

  document.addEventListener("shopify:section:load", function (event) {
    initProductGallery(event.target);
  });

  // ===================== COMMUNITY STATS COUNTER =====================
  (function initCommunityCounters() {
    var section = root.querySelector(".bb-community-section");
    if (!section) return;

    var numbers = section.querySelectorAll(".bb-community-number");
    if (!numbers.length) return;

    var hasAnimated = false;
    var prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function parseStat(text) {
      var cleaned = String(text || "").trim().toUpperCase();
      var suffix = "";

      if (cleaned.indexOf("K") !== -1) suffix = "K";
      if (cleaned.indexOf("M") !== -1) suffix = "M";

      var numeric = parseFloat(cleaned.replace(/[^0-9.]/g, "")) || 0;
      var plus = cleaned.indexOf("+") !== -1;

      return {
        value: numeric,
        suffix: suffix,
        plus: plus,
        decimals: numeric % 1 === 0 ? 0 : 1,
      };
    }

    function formatStat(value, stat) {
      return (
        value.toFixed(stat.decimals) +
        stat.suffix +
        (stat.plus ? "+" : "")
      );
    }

    function animateNumber(el) {
      var stat = parseStat(el.textContent);
      var duration = 1200;
      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;

        var progress = Math.min((timestamp - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = stat.value * eased;

        el.textContent = formatStat(current, stat);

        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          el.textContent = formatStat(stat.value, stat);
        }
      }

      el.textContent = formatStat(0, stat);
      window.requestAnimationFrame(step);
    }

    function runCounters() {
      if (hasAnimated) return;
      hasAnimated = true;

      if (prefersReducedMotion) return;

      numbers.forEach(function (number, index) {
        setTimeout(function () {
          animateNumber(number);
        }, index * 120);
      });
    }

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              runCounters();
              observer.disconnect();
            }
          });
        },
        {
          threshold: 0.35,
        }
      );

      observer.observe(section);
    } else {
      runCounters();
    }
  })();

  // ===================== CART BADGE / AJAX CART =====================
  var cartButton = document.getElementById("bb-cart-button");
  var cartBadge;

  function ensureCartBadge() {
    if (cartBadge) return cartBadge;
    if (!cartButton) return null;

    var iconWrapper = cartButton.querySelector(".bb-cart-icon-wrapper");
    if (!iconWrapper) {
      iconWrapper = document.createElement("span");
      iconWrapper.className = "bb-cart-icon-wrapper";
      var icon = cartButton.querySelector(".bb-cart-icon");
      if (icon) {
        icon.parentNode.insertBefore(iconWrapper, icon);
        iconWrapper.appendChild(icon);
      } else {
        cartButton.appendChild(iconWrapper);
      }
    }

    cartBadge = document.createElement("span");
    cartBadge.id = "bb-cart-count-badge";
    cartBadge.className = "bb-cart-count-badge";
    cartBadge.style.display = "none";
    cartBadge.textContent = "0";
    iconWrapper.appendChild(cartBadge);
    return cartBadge;
  }

  function updateCartBadge(count) {
    var badge = ensureCartBadge();
    if (!badge) return;
    if (count > 0) {
      badge.textContent = String(count);
      badge.style.display = "inline-flex";
    } else {
      badge.textContent = "0";
      badge.style.display = "none";
    }
  }

  function fetchCartCount() {
    fetch(getShopifyCartUrl("cart.js"), { credentials: "same-origin" })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        updateCartBadge(data.item_count || 0);
      })
      .catch(function () {});
  }

  fetchCartCount();

  if (cartButton) {
    cartButton.addEventListener("click", function () {
      window.location.href = getShopifyCartUrl("cart");
    });
  }

  function getShopifyCartUrl(path) {
    var rootPath =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    return rootPath + path.replace(/^\/+/, "");
  }

  function addLineItemAjax(variantId, quantity, properties, onSuccess, onError) {
    if (!variantId) {
      if (typeof onError === "function") {
        onError({ description: "Missing product variant ID." });
      }
      return;
    }

    var payload = {
      id: Number(variantId),
      quantity: quantity || 1
    };

    if (properties && Object.keys(properties).length) {
      payload.properties = properties;
    }

    fetch(getShopifyCartUrl("cart/add.js"), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        fetchCartCount();
        if (typeof onSuccess === "function") onSuccess(data);
      })
      .catch(function (error) {
        console.error("Shopify cart error:", error);
        if (typeof onError === "function") onError(error);
      });
  }

  var bassBootVariantIds = {
    Chrome: {
      "US Women’s 5 / Men’s 3.5": 52306788155694,
      "US Women’s 6 / Men’s 4.5": 52306788188462,
      "US Women’s 7 / Men’s 5.5": 52306788221230,
      "US Women’s 8 / Men’s 6.5": 52306788253998,
      "US Women’s 9 / Men’s 7.5": 52306788286766,
      "US Women’s 10 / Men’s 8.5": 52306788319534,
      "US Women’s 11 / Men’s 9.5": 52306788352302,
      "US Women’s 12 / Men’s 10.5": 52306788385070,
      "US Women’s 13 / Men’s 11.5": 52306788417838,
      "US Women’s 14 / Men’s 12.5": 52306788450606,
      "US Women’s 15 / Men’s 13.5": 52306788483374,
      "US Women’s 16 / Men’s 14.5": 52306788516142,
      "US Women’s 17 / Men’s 15.5": 52306788548910,
      "US Women’s 18 / Men’s 16.5": 52306788581678
    },
    Black: {
      "US Women’s 5 / Men’s 3.5": 52306788614446,
      "US Women’s 6 / Men’s 4.5": 52306788647214,
      "US Women’s 7 / Men’s 5.5": 52306788679982,
      "US Women’s 8 / Men’s 6.5": 52306788712750,
      "US Women’s 9 / Men’s 7.5": 52306788745518,
      "US Women’s 10 / Men’s 8.5": 52306788778286,
      "US Women’s 11 / Men’s 9.5": 52306788811054,
      "US Women’s 12 / Men’s 10.5": 52306788843822,
      "US Women’s 13 / Men’s 11.5": 52306788876590,
      "US Women’s 14 / Men’s 12.5": 52306788909358,
      "US Women’s 15 / Men’s 13.5": 52306788942126,
      "US Women’s 16 / Men’s 14.5": 52306788974894,
      "US Women’s 17 / Men’s 15.5": 52306789007662,
      "US Women’s 18 / Men’s 16.5": 52306789040430
    }
  };

  function getBassBootVariantId(color, size) {
    if (!bassBootVariantIds[color]) return 0;
    return bassBootVariantIds[color][size] || 0;
  }

  function addBassBootItemsSequentially(items, onSuccess, onError) {
    var index = 0;

    function addNext() {
      if (index >= items.length) {
        if (typeof onSuccess === "function") onSuccess();
        return;
      }

      var item = items[index];
      addLineItemAjax(
        item.id,
        item.quantity,
        {},
        function () {
          index += 1;
          addNext();
        },
        function (error) {
          if (typeof onError === "function") onError(error);
        }
      );
    }

    addNext();
  }

  // ===================== BUNDLE LOGIC (1/2/3 PAIRS) =====================
  var bundleCards = root.querySelectorAll(".bb-bundle-card");
  var mainCta = document.getElementById("bb-main-cta");

  var selectedBundle = 1; // 1, 2, or 3
  var selectedSizes = {
    1: "",
    2: "",
    3: "",
  };
  var selectedColors = {
    1: "Chrome",
    2: "Chrome",
    3: "Chrome",
  };

  var sizeOptions = [
    "",
    "US Women’s 5 / Men’s 3.5",
    "US Women’s 6 / Men’s 4.5",
    "US Women’s 7 / Men’s 5.5",
    "US Women’s 8 / Men’s 6.5",
    "US Women’s 9 / Men’s 7.5",
    "US Women’s 10 / Men’s 8.5",
    "US Women’s 11 / Men’s 9.5",
    "US Women’s 12 / Men’s 10.5",
    "US Women’s 13 / Men’s 11.5",
    "US Women’s 14 / Men’s 12.5",
    "US Women’s 15 / Men’s 13.5",
    "US Women’s 16 / Men’s 14.5",
    "US Women’s 17 / Men’s 15.5",
    "US Women’s 18 / Men’s 16.5",
  ];

  function getBundleSizeFromCard(card) {
    if (!card) return 1;
    var b = parseInt(card.getAttribute("data-bundle") || "1", 10);
    return b >= 1 && b <= 3 ? b : 1;
  }

  function getActiveBundleCard() {
    return root.querySelector(".bb-bundle-card.bb-bundle-active");
  }

  function colorLabelFromValue(value) {
    return value === "black" ? "Black" : "Chrome";
  }

  function setColorSelectedForPair(card, pairIndex, colorValue) {
    if (!card) return;

    var selector = '.bb-style-option[data-pair-index="' + pairIndex + '"]';
    var options = card.querySelectorAll(selector);

    options.forEach(function (opt) {
      var isSelected = opt.getAttribute("data-style") === colorValue;
      opt.classList.toggle("bb-style-selected", isSelected);
      opt.setAttribute("aria-pressed", isSelected ? "true" : "false");

      var dot = opt.querySelector(".bb-style-dot");
      if (dot) {
        dot.classList.toggle("bb-style-dot-active", isSelected);
      }
    });
  }

  function setDefaultColorsForCard(card) {
    if (!card) return;
    var bundleSize = getBundleSizeFromCard(card);

    for (var i = 1; i <= bundleSize; i++) {
      if (!selectedColors[i]) selectedColors[i] = "Chrome";
      var colorValue = selectedColors[i] === "Black" ? "black" : "chrome";
      setColorSelectedForPair(card, i, colorValue);
    }
  }

  // Build per-pair color selectors + size dropdowns inside each card at runtime
  function buildBundleDetails() {
    bundleCards.forEach(function (card) {
      var bundleSize = getBundleSizeFromCard(card);
      // Avoid double-inserting if this script runs twice somehow
      if (card.querySelector(".bb-bundle-details")) return;

      var details = document.createElement("div");
      details.className = "bb-bundle-details";

      // Color + size controls for each pair
      for (var i = 1; i <= bundleSize; i++) {
        var pairBlock = document.createElement("div");
        pairBlock.className = "bb-pair-details";
        pairBlock.setAttribute("data-pair-index", String(i));

        var pairTitle = document.createElement("div");
        pairTitle.className = "bb-pair-title";
        pairTitle.textContent = "Pair " + i;
        pairBlock.appendChild(pairTitle);

        var styleRow = document.createElement("div");
        styleRow.className = "bb-style-row";

        var chromeOption = document.createElement("button");
        chromeOption.type = "button";
        chromeOption.className = "bb-style-option bb-style-selected";
        chromeOption.setAttribute("data-style", "chrome");
        chromeOption.setAttribute("data-pair-index", String(i));
        chromeOption.setAttribute("aria-pressed", "true");
        chromeOption.innerHTML =
          '<span class="bb-style-dot bb-style-dot-chrome bb-style-dot-active"></span>' +
          '<span class="bb-style-label">Chrome</span>';

        var blackOption = document.createElement("button");
        blackOption.type = "button";
        blackOption.className = "bb-style-option";
        blackOption.setAttribute("data-style", "black");
        blackOption.setAttribute("data-pair-index", String(i));
        blackOption.setAttribute("aria-pressed", "false");
        blackOption.innerHTML =
          '<span class="bb-style-dot bb-style-dot-black"></span>' +
          '<span class="bb-style-label">Black</span>';

        styleRow.appendChild(chromeOption);
        styleRow.appendChild(blackOption);
        pairBlock.appendChild(styleRow);

        var row = document.createElement("div");
        row.className = "bb-sizes-row";

        var label = document.createElement("label");
        label.className = "bb-size-label";
        label.textContent = "Size";

        var select = document.createElement("select");
        select.className = "bb-size-select";
        select.setAttribute("data-bundle", String(bundleSize));
        select.setAttribute("data-pair-index", String(i));

        sizeOptions.forEach(function (val, idx) {
          var opt = document.createElement("option");
          opt.value = val;
          opt.textContent = idx === 0 ? "Select size" : val;
          if (idx === 0) opt.selected = true;
          select.appendChild(opt);
        });

        row.appendChild(label);
        row.appendChild(select);
        pairBlock.appendChild(row);
        details.appendChild(pairBlock);
      }

      card.appendChild(details);
      setDefaultColorsForCard(card);
    });
  }

  buildBundleDetails();

  function resetBundleSelections() {
    selectedSizes[1] = "";
    selectedSizes[2] = "";
    selectedSizes[3] = "";

    selectedColors[1] = "Chrome";
    selectedColors[2] = "Chrome";
    selectedColors[3] = "Chrome";

    var active = getActiveBundleCard();
    if (!active) return;

    var selects = active.querySelectorAll(".bb-size-select");
    selects.forEach(function (sel) {
      sel.value = "";
    });

    setDefaultColorsForCard(active);
  }

  function allRequiredSelectionsChosen() {
    for (var i = 1; i <= selectedBundle; i++) {
      if (!selectedColors[i]) return false;
      if (!selectedSizes[i]) return false;
    }
    return true;
  }

  function updateMainCtaState() {
    if (!mainCta) return;
    var validSelections = allRequiredSelectionsChosen();
    if (validSelections) {
      mainCta.disabled = false;
      mainCta.classList.remove("bb-main-cta-disabled");
    } else {
      mainCta.disabled = true;
      mainCta.classList.add("bb-main-cta-disabled");
    }
  }

  // Card click (radio behavior)
  bundleCards.forEach(function (card) {
    card.addEventListener("click", function (e) {
      // Ignore clicks on selects or style options
      if (e.target.closest(".bb-size-select") || e.target.closest(".bb-style-option")) {
        return;
      }

      bundleCards.forEach(function (c) {
        c.classList.remove("bb-bundle-active");
      });
      card.classList.add("bb-bundle-active");

      selectedBundle = getBundleSizeFromCard(card);
      resetBundleSelections();
      updateMainCtaState();
    });

    // Per-pair color selectors inside each card
    var styleOptions = card.querySelectorAll(".bb-style-option");
    styleOptions.forEach(function (opt) {
      opt.addEventListener("click", function (e) {
        e.stopPropagation();

        var pairIndex = parseInt(opt.getAttribute("data-pair-index") || "1", 10) || 1;
        var styleValue = opt.getAttribute("data-style") || "chrome";

        selectedColors[pairIndex] = colorLabelFromValue(styleValue);
        setColorSelectedForPair(card, pairIndex, styleValue);
        updateMainCtaState();
      });
    });

    // Size selects inside each card
    var selects = card.querySelectorAll(".bb-size-select");
    selects.forEach(function (sel) {
      sel.addEventListener("click", function (e) {
        e.stopPropagation();
      });
      sel.addEventListener("change", function () {
        var pairIndex = parseInt(sel.getAttribute("data-pair-index") || "1", 10) || 1;
        selectedSizes[pairIndex] = sel.value || "";
        updateMainCtaState();
      });
    });
  });

  // Initialize default: first card active, Chrome color per pair, no sizes chosen
  var firstCard = root.querySelector('.bb-bundle-card[data-bundle="1"]');
  if (firstCard) {
    firstCard.classList.add("bb-bundle-active");
    selectedBundle = 1;
    setDefaultColorsForCard(firstCard);
  }
  updateMainCtaState();

  // ===================== MAIN CTA → ADD SELECTED BASS BOOTS VARIANTS =====================
  if (mainCta) {
    mainCta.addEventListener("click", function () {
      if (mainCta.disabled) return;

      if (!allRequiredSelectionsChosen()) {
        updateMainCtaState();
        return;
      }

      var groupedItems = {};
      var missingSelection = "";

      for (var i = 1; i <= selectedBundle; i++) {
        var color = selectedColors[i];
        var size = selectedSizes[i];
        var variantId = getBassBootVariantId(color, size);

        if (!variantId) {
          missingSelection = color + " / " + size;
          break;
        }

        if (!groupedItems[variantId]) {
          groupedItems[variantId] = {
            id: variantId,
            quantity: 0
          };
        }

        groupedItems[variantId].quantity += 1;
      }

      if (missingSelection) {
        alert(
          "We couldn’t match this selection to a Shopify variant: " +
            missingSelection +
            ". Please refresh and try again."
        );
        return;
      }

      var items = Object.keys(groupedItems).map(function (variantId) {
        return groupedItems[variantId];
      });

      mainCta.disabled = true;
      mainCta.classList.add("bb-main-cta-disabled");

      addBassBootItemsSequentially(
        items,
        function () {
          window.location.href = getShopifyCartUrl("checkout");
        },
        function (error) {
          mainCta.disabled = false;
          mainCta.classList.remove("bb-main-cta-disabled");

          var message =
            (error && (error.description || error.message)) ||
            "Shopify rejected the selected variant.";

          alert(
            "Bass Boots could not be added to the cart. Shopify says: " +
              message
          );
        }
      );
    });
  }

  // ===================== ADD-ON PRODUCTS (AJAX) =====================
  var addonButtons = root.querySelectorAll(".bb-addon-btn");
  addonButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var vid = parseInt(btn.getAttribute("data-variant-id") || "0", 10);
      if (!vid) {
        console.warn("Missing data-variant-id on add-on button.");
        return;
      }
      addLineItemAjax(vid, 1, {}, function () {
        // stay on page, badge updates via fetchCartCount
      });
    });
  });

  // ===================== ACCORDIONS =====================
  var accordions = root.querySelectorAll("[data-accordion]");
  accordions.forEach(function (acc) {
    var header = acc.querySelector(".bb-accordion-header");
    if (!header) return;
    header.addEventListener("click", function () {
      acc.classList.toggle("bb-accordion-open");
    });
  });

  // ===================== STICKY BOTTOM CTA (scroll up) =====================
  (function initStickyCta() {
    var sticky = root.querySelector(".bb-sticky-cta");
    var stickyBtn = sticky ? sticky.querySelector(".bb-sticky-cta-btn") : null;
    var lastScrollY = window.scrollY;

    if (!sticky || !stickyBtn) return;

    window.addEventListener("scroll", function () {
      var currentY = window.scrollY;
      if (currentY > 400 && currentY < lastScrollY - 10) {
        sticky.classList.add("bb-sticky-cta-visible");
      } else if (currentY > lastScrollY + 10) {
        sticky.classList.remove("bb-sticky-cta-visible");
      }
      lastScrollY = currentY;
    });

    stickyBtn.addEventListener("click", function () {
      var bundles = document.getElementById("bb-bundles");
      smoothScrollTo(bundles);
    });
  })();

  // ===================== HAMBURGER MENU (Home / FAQ / Contact) =====================
  (function initMenu() {
    var hamburger = document.getElementById("bb-hamburger-button");
    if (!hamburger) return;

    var overlay = document.createElement("div");
    overlay.id = "bb-menu-overlay";
    overlay.className = "bb-menu-overlay";

    overlay.innerHTML =
      '<div class="bb-menu-panel">' +
      '<button type="button" class="bb-menu-close" aria-label="Close menu">×</button>' +
      '<nav class="bb-menu-nav">' +
      '<button type="button" class="bb-menu-link" data-menu-target="home">Home</button>' +
      '<button type="button" class="bb-menu-link" data-menu-target="faq">FAQ</button>' +
      '<button type="button" class="bb-menu-link" data-menu-target="contact">Contact</button>' +
      "</nav>" +
      "</div>";

    document.body.appendChild(overlay);

    var closeBtn = overlay.querySelector(".bb-menu-close");
    var menuLinks = overlay.querySelectorAll(".bb-menu-link");
    var faqSection = document.getElementById("bb-faq");
    var contactFooter = document.getElementById("bb-contact-footer");

    function openMenu() {
      overlay.classList.add("bb-menu-open");
    }
    function closeMenu() {
      overlay.classList.remove("bb-menu-open");
    }

    hamburger.addEventListener("click", function () {
      if (overlay.classList.contains("bb-menu-open")) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", closeMenu);
    }

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeMenu();
    });

    menuLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        var target = link.getAttribute("data-menu-target");
        if (target === "home") {
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else if (target === "faq" && faqSection) {
          smoothScrollTo(faqSection);
        } else if (target === "contact" && contactFooter) {
          smoothScrollTo(contactFooter);
        }
        closeMenu();
      });
    });
  })();
})();